'use strict';

require('../tasks/CompanyTaskCategoryService.js');

function CompanySettingTaskCategoriesCtrl(
  $scope,
  $translate,
  taskCategories,
  $stateParams,
  $state,
  $window,
  CompanyTaskService,
  growl
) {
  $scope.taskCategories = taskCategories;


  $scope.addTaskCategory = function() {
    $scope.taskCategories.push({
      name: '',
      color: 4279856278, // #196c96
    });

    $scope.lastItem = $scope.taskCategories.length - 1;
  };

  $scope.saveTaskCategories = function() {
    CompanyTaskService.updateCategories({companyId: $stateParams.companyId}, $scope.taskCategories, function() {
      $window.location.reload();
      growl.addSuccessMessage($translate.instant('settings.save-task-categories-success'));
    });
  };
}

CompanySettingTaskCategoriesCtrl.resolve = {
  taskCategories: ['$stateParams', 'CompanyTaskService', function($stateParams, CompanyTaskService) {
    return CompanyTaskService.queryCategories({companyId: $stateParams.companyId}).$promise;
  }]
};
module.exports = CompanySettingTaskCategoriesCtrl;

angular.module('dokiv')
  .controller('CompanySettingTaskCategoriesCtrl', [
  '$scope',
  '$translate',
  'taskCategories',
  '$stateParams',
  '$state',
  '$window',
  'CompanyTaskService',
  'growl',
  CompanySettingTaskCategoriesCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/settings/CompanySettingTaskCategoriesCtrl.js
// module id = 413
// module chunks = 0